const state = {
    searchId:'',//搜索类型
    keyWords: '', // 搜索内容
    searchType:[
        {id:1,name:'铸造机加工外协找厂',type:1}, //加工厂买家 找加工厂
        {id:2,name:'仪器设备材料供应商',type:1},//加工厂买家 找供应商
        {id:3,name:'铸造机加工产品',type:2},
        {id:4,name:'仪器设备材料产品',type:2},
        {id:5,name:'找询盘信息',type:3},
        {id:6,name:'仪器设备询价',type:3},
        {id:7,name:'铸件机加工询价',type:3},
    ],
}
const mutations = {
    SET_SEARCHID: (state, id) => {//设置搜索ID
        state.searchId = id
    },
    SET_KEYWORDS: (state, keyWords) => {//设置搜索内容
        state.keyWords = keyWords
    }
}
const actions = {
    set_searchId({ commit }, id){
        commit('SET_SEARCHID', id)
    },
    set_keywords({ commit }, keyWords){
        commit('SET_KEYWORDS', keyWords)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}